// Centralized media URLs for the brand
export const MEDIA = {
  logo: "/assets/frdm-logo.png",
  hero_cup:
    "https://static.prod-images.emergentagent.com/jobs/34d2957f-4eaa-4df3-b378-7a71422dc75b/images/90d0937a950d5ff9f68423c6b09c68c4ce4308ae5e02862c08d4293513b954ae.png",
  open_road:
    "https://static.prod-images.emergentagent.com/jobs/34d2957f-4eaa-4df3-b378-7a71422dc75b/images/b47b65369178c1b790fe434908ef398b61455a011eb6a628f11df60808f79cc6.png",
  cafe_interior:
    "https://static.prod-images.emergentagent.com/jobs/34d2957f-4eaa-4df3-b378-7a71422dc75b/images/51c4edc297a6f183852ff356dbf40d5fddc12969c8fa08072e50cf067fe55f2d.png",
  coffee_beans:
    "https://static.prod-images.emergentagent.com/jobs/34d2957f-4eaa-4df3-b378-7a71422dc75b/images/6e1fce2bc04e2779ce1018fdaf2aa2061c1763849357fa0d56abda7fa481aa87.png",
  hands_clinking:
    "https://static.prod-images.emergentagent.com/jobs/34d2957f-4eaa-4df3-b378-7a71422dc75b/images/420e30435a63fc477059dcd3cc77f275b92c044a6c948ef972f42d28027740f6.png",
  main_street_bw:
    "https://static.prod-images.emergentagent.com/jobs/34d2957f-4eaa-4df3-b378-7a71422dc75b/images/a58b4d6610448caa7381fabc62d49dfb6667c26022569c4a9dccaee538f04f3a.png",
  sf_storefront:
    "https://static.prod-images.emergentagent.com/jobs/34d2957f-4eaa-4df3-b378-7a71422dc75b/images/5973bdf37b855d6192fb42e467630d948c31b53650dc389c75511f9002781510.png",
};
